import Motorists from "./Motorists";

export default Motorists;
